export const customTags = [
  { label: 'FORMAT', type: 'keyword' },
  { label: 'ORGANIZATION', type: 'keyword' },
  { label: 'BENEFICIARY', type: 'keyword' },
]
